module.exports = __webpack_public_path__ + "static/media/Flyer1.7975c77e.png";